module.exports = __webpack_public_path__ + "media/images/uc_logo_black-50c1901d96fb73b7b935b5da7f01a06d.png";